import React from 'react'
import Duration from 'support/displays/Duration'

export default function DurationFromSeconds (props) {
  return (
    <Duration {...props} fromSeconds />
  )
}
